import React, { useEffect, useState } from 'react';

import RenderFieldBasedOnType from '../../RenderFieldsBasedOnType';
import {
    Box, Button,
    Dialog, DialogActions, DialogContent, DialogTitle,
    Divider, Grid,
    Typography, OutlinedInput
} from '@material-ui/core'
import { Helpers, FilterSelect, ConfirmationHandler } from "dsilo-ui-components";
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
    statusDiv: {
        display: 'flex',
        justifyContent: 'space-between',
        border: '1px solid #ddd',
        alignItems: 'center',
        borderRadius: 4,
        padding: 5,
        marginTop: 10,
        fontSize: 13,
    },
    statusDivAction: {
        display: 'flex',
        alignItems: 'center',
    },
    rootContainer: {
        marginTop: "20px"
    },
    titleBlock: {
        display: "flex",
        alignItems: "center"
    },
    title: {
        fontWeight: "bold",
        fontSize: "14px"
    },
    addIcon: {
        marginLeft: "8px",
        cursor: "pointer"
    },
    tableHeaderCell: {
        // borderBottom:"none"
    },
    tableActions: {
        display: "flex",
        alignItems: "center"
    },
    actionIcon: {
        cursor: "pointer"
    },
    inputField: {
        width: "100%",
        height: "35px",
        paddingLeft: "5px"
    },
    selectField: {
        height: "35px",
    }
}))

/* For now It is static */
const defaultOptions = {
    // vendorName: [
    //     {
    //         value: "Vendor 1",
    //         label: "Vendor 1"
    //     },
    //     {
    //         value: "Vendor 2",
    //         label: "Vendor 2"
    //     }
    // ],
    assignedTo: [
        {
            value: "User 1",
            label: "User 1"
        },
        {
            value: "User 2",
            label: "User 2"
        }
    ],
    status: [
        {
            value: "Pending",
            label: "Pending"
        },
        {
            value: "In Progress",
            label: "In Progress"
        }
    ]
}

const SummaryBlock = (props) => {
    const classes = useStyles()

    const { orgId, appId, currentDocumentId, formData, selectedStep, block, blockState, handleCheckboxChange, onChange, selectedOptions, stateObj, keyName } = props
    const { document } = props.formData
    const { chartUniqueId } = props.data

    const [blockHeaders, setBlockHeaders] = useState([])
    const [executedLabel, setExecutedLabel] = useState('');

    const [anchorEl, setAnchorEl] = useState(null);
    const [allTasksCompleted, setAllTasksCompleted] = useState(false);
    const [confirmationDialog, setConfirmationDialog] = useState({
        isOpen: false,
        message: '',
        cb: null,
        cbType: null
    });

    const shouldDisableFields = props.enableWorkflow && !(
        block?.workflowStepId === blockState?.workflow?.id &&
        blockState?.workflow?.currentRespondent?.id === props.members?._id
    );
    console.log('SummaryBlock***props', blockState, block, props.members)

    // console.log("Props Log ====> ", props, "\n\n\n stateObj  ===>>>> ", stateObj);

    // Below UseEffect is used getting the BlockHeader from dataElements of DataModel Data and the Current Block
    useEffect(() => {
        if (formData?.dataModel[selectedStep.dataModel]) {
            let dataElements = formData.dataModel[selectedStep.dataModel].dataElements || []
            if (dataElements?.length) {
                let fdes = []
                if (block.config.dataElements) {
                    // console.log("Cmng here 111 ===> ", block.config.dataElements, dataElements );
                    fdes = JSON.parse(JSON.stringify(block.config.dataElements))
                    fdes = fdes.map(fde => {
                        let sde = dataElements.find(de => de.name === fde.value)
                        // console.log("Sde -====>> ", sde, sde?.name);
                        if (sde?.name) {
                            return {
                                ...sde,
                                ...fde
                            }
                        } else {
                            return fde
                        }
                    })
                    setBlockHeaders(fdes)
                }
            }
        }
    }, [formData?.dataModel])

    useEffect(() => {
        if (props.formData?.document[chartUniqueId + '_executeWorkflow']) {
            const executeWorkFlow = props.formData?.document[chartUniqueId + '_executeWorkflow']
            const message = executeWorkFlow?.message || "Workflow executed successfully"
            showConfirmationDialogORToast(message, 'success', commonCallBacksOnWorkflowSuccess, 'execute useeffect')
        } else {
            console.log("Error in Update Identify Step");
        }
    }, [props.formData?.document[chartUniqueId + '_executeWorkflow']])

    useEffect(() => {
        if (document?.[chartUniqueId + '_executeWorkflow_reject']) {
            const rejectWorkFlow = document[chartUniqueId + '_executeWorkflow_reject']
            const message = rejectWorkFlow?.message || "Workflow executed successfully"
            showConfirmationDialogORToast(message, 'success', commonCallBacksOnWorkflowSuccess, 'execute useeffect')
        }
    }, [document?.[chartUniqueId + '_executeWorkflow_reject']])

    useEffect(() => {
        if (confirmationDialog?.invokeCallback && confirmationDialog?.cb) {
            confirmationDialog?.cb(confirmationDialog.cbType || "");
            setConfirmationDialog({
                ...confirmationDialog,
                cb: null,
                invokeCallback: false,
                cbType: null
            })
        }
    }, [confirmationDialog])

    const getNextRespondents = () => {
        let data = [];
        (props.formData?.document[chartUniqueId + '_nextRespondent'] || []).map(i => {
            if (i.id || i._id) {
                data.push({
                    value: i.id || i._id,
                    label: i.name
                })
            }
        })
        return data
    }

    const handleAssignMembers = (v) => {
        props.handleAssignMembers(v)
        setAnchorEl(null)
    }

    const onClose = () => {
        setAnchorEl(null)
    }

    const isLoading = () => {
        return props.formData?.[chartUniqueId + '_nextRespondent_loading']
    }

    const handleMoveClick = (event, str, obj) => {
        if (obj.type === "end") {
            setExecutedLabel(obj?.label)
            props.fetchNextRespondents(str, obj)
            event.stopPropagation();
            setAnchorEl(event.currentTarget)
        } else {
            props.fetchNextRespondents(str, obj)
            setExecutedLabel(obj?.label)
            event.stopPropagation();
            setAnchorEl(event.currentTarget)
        }
    }

    const clearCurrentChartReduxStore = () => {
        let subKeys = [
            chartUniqueId + '_executeWorkflow',
            chartUniqueId + '_executeWorkflow_reject',
            chartUniqueId + '_reject_to_qa',
            chartUniqueId + '_assign',
            chartUniqueId + '_exceptionMessages',
            chartUniqueId + '_saveSageIntacct',
            chartUniqueId + '_reinitiateworkflow',
        ]
        // for clearing success/Reject message
        props.clearReduxDataOfCurrentComponent({
            key: "document",
            subKey: subKeys
        })
    }

    const commonCallBacksOnWorkflowSuccess = (type = null) => {
        clearCurrentChartReduxStore()
        props.fetchSingleObligation()
    }

    const showConfirmationDialogORToast = (messageText, displayType, cb, from) => {
        setConfirmationDialog({
            isOpen: true,
            message: messageText,
            cb,
            cbType: from
        })
    }

    const handleCloseConfirmationDialog = () => {
        let obj = {
            ...confirmationDialog,
            isOpen: false,
            message: '',
        }

        // If we want to perform some action after closing confirmation dialog
        if (confirmationDialog?.cb) {
            obj.invokeCallback = true
        }

        setConfirmationDialog(obj)
    }

    const showHideWorkFlow = (obj) => {
        setAllTasksCompleted(obj)
    }


    return (
        <React.Fragment>
            {
                props.enableWorkflow ? (
                    <Grid container spacing={1}>
                        {
                            blockHeaders?.length > 0 ? blockHeaders.map((element, index) => {
                                const sValue = Helpers.generateValueByDataElementType(blockState, element) || '-'
                                const isFieldReadOnly = shouldDisableFields || element.readOnly;

                                return (
                                    <Grid
                                        item
                                        key={index}
                                        xs={element.xs ? element.xs : (12 / blockHeaders.length)}
                                        style={{ marginTop: "2px", marginBottom: "2px" }}
                                    >
                                        <Box style={{ width: "100%" }}>
                                            <Grid container style={{ display: "grid", gridTemplateRows: "auto auto" }}>
                                                <div>
                                                    <Typography
                                                        component='span'
                                                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                    >
                                                        {element.label}
                                                    </Typography>
                                                </div>

                                                {isFieldReadOnly ? (
                                                    <div style={{ marginTop: "4px", width: "100%" }}>
                                                        <RenderFieldBasedOnType
                                                            {...props}
                                                            classes={classes}
                                                            element={{ ...element, readOnly: true }}
                                                            onChange={onChange}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                            dataObj={blockState}
                                                            options={defaultOptions[element.value || element.name]}
                                                            selectedStep={selectedStep}
                                                        />
                                                    </div>
                                                ) : (
                                                    <div style={{ marginTop: "4px", width: "100%" }}>
                                                        <RenderFieldBasedOnType
                                                            {...props}
                                                            classes={classes}
                                                            element={element}
                                                            onChange={onChange}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                            dataObj={blockState}
                                                            options={defaultOptions[element.value || element.name]}
                                                            selectedStep={selectedStep}
                                                        />
                                                    </div>
                                                )}
                                            </Grid>
                                        </Box>
                                    </Grid>
                                )
                            }) : (
                                <Typography>{`No Fields are Configured`}</Typography>
                            )
                        }
                    </Grid>
                ) : (
                    <Grid container spacing={1}>
                        {
                            blockHeaders?.length > 0 ? blockHeaders.map((element, index) => {
                                const sValue = Helpers.generateValueByDataElementType(blockState, element) || '-'
                                const isFieldReadOnly = shouldDisableFields || element.readOnly;

                                return (
                                    <Grid
                                        item
                                        key={index}
                                        xs={element.xs ? element.xs : (12 / blockHeaders.length)}
                                        style={{ marginTop: "2px", marginBottom: "2px" }}
                                    >
                                        <Box style={{ width: "100%" }}>
                                            <Grid container style={{ display: "grid", gridTemplateRows: "auto auto" }}>
                                                <div>
                                                    <Typography
                                                        component='span'
                                                        style={{ fontWeight: 'bold', fontSize: '14px' }}
                                                    >
                                                        {element.label}
                                                    </Typography>
                                                </div>

                                                {isFieldReadOnly ? (
                                                    <div>
                                                        <Typography
                                                            component='span'
                                                            style={{ fontSize: '14px' }}
                                                        >
                                                            {sValue}
                                                        </Typography>
                                                    </div>
                                                ) : (
                                                    <div style={{ marginTop: "4px", width: "100%" }}>
                                                        <RenderFieldBasedOnType
                                                            {...props}
                                                            classes={classes}
                                                            element={element}
                                                            onChange={onChange}
                                                            handleCheckboxChange={handleCheckboxChange}
                                                            dataObj={blockState}
                                                            options={defaultOptions[element.value || element.name]}
                                                            selectedStep={selectedStep}
                                                        />
                                                    </div>
                                                )}
                                            </Grid>
                                        </Box>
                                    </Grid>
                                )
                            }) : (
                                <Typography>{`No Fields are Configured`}</Typography>
                            )
                        }
                    </Grid>
                )
            }

            {
                props.enableWorkflow && !shouldDisableFields && Boolean(Object.keys(props?.nextTask || {}).length) && Array.isArray(props?.nextTask?.currentPossibleAction) && props?.nextTask?.currentPossibleAction.map((cpa, index) => {
                    const disableMoveButton = cpa?.label === "Realization" && !allTasksCompleted;
                    return (
                        <Grid item xs={12} key={cpa?.id || index} style={{ display: 'flex', justifyContent: 'end', gap: '10px' }}>
                            {
                                props.enableEdit ? <Grid item xs={4} style={{ maxWidth: "fit-content" }}>
                                    <div style={{}} />
                                    <div style={{ marginBottom: 10 }} />
                                    <Button
                                        color="primary"
                                        onClick={props.handleSave}
                                        style={{ width: "auto", fontSize: "13px" }}
                                        variant="contained"

                                    >
                                        Save
                                    </Button>
                                </Grid> : null
                            }
                            {
                                props.enableRejectButton && props.workflow?.type !== "start" && props.workflow?.type !== "end" ? <Grid item xs={4} style={{ maxWidth: "fit-content" }}>
                                    <div style={{}} />
                                    {/* margin: 10 removed from above style */}
                                    <div style={{ marginBottom: 10 }} />
                                    <Button
                                        onClick={props.handleReject}
                                        style={{ width: "auto", fontSize: "13px", color: 'white', backgroundColor: 'red' }}
                                        variant="contained"

                                    >
                                        Reject
                                    </Button>
                                </Grid> : null
                            }
                            {Object.keys(cpa || {}).length > 0 && (
                                <div style={{ marginTop: 10 }}>
                                    <Button
                                        style={{ width: "auto", fontSize: "13px" }}
                                        variant="contained"
                                        color="primary"
                                        disabled={disableMoveButton}
                                        onClick={(e) => handleMoveClick(e, 'current', cpa)}
                                    >
                                        {`Move to ${cpa?.label}`}
                                    </Button>
                                </div>
                            )}
                        </Grid>
                    );
                })
            }
            {
                props.enableWorkflow && anchorEl && <FilterSelect
                    loader={props.loader}
                    allValues={getNextRespondents()}
                    anchorEl={anchorEl}
                    id={anchorEl ? 'transitions-popper' : undefined}
                    selectedValues={[]}
                    enablingLoader={isLoading()}
                    onClose={onClose}
                    isOpen={anchorEl}
                    onSave={(val) => {
                        handleAssignMembers(val)
                    }}
                />
            }
            {confirmationDialog.isOpen && (
                <ConfirmationHandler
                    open={confirmationDialog.isOpen}
                    handleClose={handleCloseConfirmationDialog}
                    alertMessageText={confirmationDialog.message}
                    transparentBackdrop={true}
                    confirm={false}
                />
            )}
        </React.Fragment>
    )
}

export default SummaryBlock